import PropTypes from "prop-types";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Link, Redirect, useHistory } from "react-router-dom";

import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

import API from "../../API";
import { withSnackbar } from "../../HOC/withSnackbar";
import { FilledTextField } from "../../components/FormElements";
import Typography from "../../components/Helpers/Typography";
import CenterWidget from "../../components/Layout/CenterWidget";
import { loginStyles } from "./sharedStyles";
import { accessTokenCookieKey, getCookies } from "../../API/cookies";

export const Login = ({ classes, t, setSnackbarMessage }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      await API.auth.login(username, password);
      history.push(history.location.state ? history.location.state.from : "/");
    } catch (err) {
      setSnackbarMessage(t("User.LoginError"));
    }
  };
  if (!getCookies?.(accessTokenCookieKey)) {
    return (
      <CenterWidget title="User.SignIn" style={{ minHeight: 350 }}>
        <form className={classes.container} onSubmit={handleSubmit}>
          <FilledTextField
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            type="text"
            label={t("User.Username")}
          />
          <FilledTextField
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            label={t("User.Password")}
          />
          <Button className={classes.submit} type="submit" variant="contained" color="secondary">
            {t("User.SignIn")}
          </Button>
        </form>
        <Link to="/reset-password" className={classes.blueButton}>
          <Typography
            color="blue"
            style={{
              textTransform: "uppercase",
              marginTop: -14,
              fontSize: 14,
              letterSpacing: 0.75,
              lineHeight: "16px",
            }}
          >
            {t("Change Password")}
          </Typography>
        </Link>
      </CenterWidget>
    );
  }
  return <Redirect to={history.location.state ? history.location.state.from : "/"} />;
};

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
};

export default withStyles(loginStyles)(withTranslation("common")(withSnackbar(Login)));
